window.urlFormatter = function(value, row) {
    let html = '';
    if (value) {
        html += '<a href="'+value+'" target="_blank" rel="noopener noreferrer">';
        html += '<i class="fas fa-external-link"></i>';
        html += '</a>';
    }
    return html;
}
